import { apiClient } from "./api";

export interface StrapiContentType {
  uid: string;
  apiID?: string;
  schema?: {
    displayName?: string;
    description?: string;
    attributes?: Record<string, { type: string; [key: string]: unknown }>;
  };
}

export interface StrapiEntry {
  id: number;
  documentId?: string;
  attributes?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface StrapiPagination {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

export interface StrapiEntriesResponse {
  data: StrapiEntry[];
  meta?: {
    pagination?: StrapiPagination;
  };
}

export async function listStrapiContentTypes(): Promise<StrapiContentType[]> {
  const response = await apiClient.get("/strapi/content-types");
  return response.data;
}

export async function listStrapiEntries(
  contentType: string,
  page = 1,
  pageSize = 25,
): Promise<StrapiEntriesResponse> {
  const response = await apiClient.get(`/strapi/${contentType}`, {
    params: { page, page_size: pageSize },
  });
  return response.data;
}

export async function getStrapiEntry(contentType: string, entryId: string | number): Promise<StrapiEntry> {
  const response = await apiClient.get(`/strapi/${contentType}/${entryId}`);
  return response.data;
}

export async function createStrapiEntry(
  contentType: string,
  data: Record<string, unknown>,
): Promise<StrapiEntry> {
  const response = await apiClient.post(`/strapi/${contentType}`, data);
  return response.data;
}

export async function updateStrapiEntry(
  contentType: string,
  entryId: string | number,
  data: Record<string, unknown>,
): Promise<StrapiEntry> {
  const response = await apiClient.put(`/strapi/${contentType}/${entryId}`, data);
  return response.data;
}

export async function deleteStrapiEntry(contentType: string, entryId: string | number): Promise<void> {
  await apiClient.delete(`/strapi/${contentType}/${entryId}`);
}
